"use strict";

var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.LastVisit = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData"),
  _utilities = require("../../utilities"),
  _types = require("../types"),
  _logging = require("../../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var LastVisit = /*#__PURE__*/function () {
  function LastVisit(a) {
    _classCallCheck(this, LastVisit);
    var b = a.matchType,
      c = a.count,
      d = a.unitOfTime;
    _defineProperty(this, "matchType", void 0), _defineProperty(this, "conditionValue", void 0), _defineProperty(this, "timeUnit", void 0), this.matchType = b, this.conditionValue = c, this.timeUnit = d;
  }
  return _createClass(LastVisit, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      var c = null === b || void 0 === b ? void 0 : b[_kameleoonData.KameleoonData.VisitsData];
      if (!(null !== c && void 0 !== c && c.visits.length)) return (0, _tsRes.Ok)(!1);
      var d = c.visits,
        e = d[d.length - 1];
      return (0, _tsRes.Ok)(this.checkCondition(e));
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      if (!this.matchType || "number" != typeof this.conditionValue || !this.timeUnit) return !1;
      var b = Date.now() - a,
        c = _utilities.Utilities.convertTimeUnit(b, this.timeUnit);
      switch (this.matchType) {
        case _types.MatchType.GREATER:
          return c > this.conditionValue;
        case _types.MatchType.LOWER:
          return c < this.conditionValue;
        default:
          return _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected comparing operation for LastVisit condition: ", ""])), this.matchType), !1;
      }
    }
  }]);
}();
exports.LastVisit = LastVisit;